export const DEFAULT_PLAYER_NAME = 'default';
